module.exports = __webpack_public_path__ + "static/img/empresa.3ff3043.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresa.png
// module id = c020
// module chunks = 0